import React from 'react'
import {
    VStack,
    HStack,
    Text,
    Button,
    useMultiStyleConfig,
    Link,
} from '@salesforce/retail-react-app/app/components/shared/ui'
//ICONS
import {EmailIcon, AdviceIcon} from '../../../components/icons'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

//HOOKS
import {useIntl} from 'react-intl'
import {useBooleanCustomPreference} from '../../../hooks/use-custom-preference'

const CartSupport = () => {
    const style = useMultiStyleConfig('Cart', {})
    const {support} = style
    const {formatMessage} = useIntl()
    const {buildUrl} = useMultiSite()
    const showSupportChatSection = useBooleanCustomPreference('showSupportChatSection')

    return (
        <VStack {...support?.supportContainer}>
            <HStack {...support?.supportEmailSection}>
                <HStack {...support?.innerEmailStack}>
                    <EmailIcon {...support?.supportIcon} aria-hidden="true" />
                    <Text {...support?.text}>
                        {formatMessage({
                            id: 'cart_default.cart_support.email_message',
                            defaultMessage: 'Send us an email by filling out the contact form',
                        })}
                    </Text>
                </HStack>
                <Button
                    as={Link}
                    href={buildUrl('/contact-us')}
                    variant="text-button"
                    aria-label={formatMessage({
                        id: 'cart_support.button.contact.label',
                        defaultMessage: 'Go to contact form',
                    })}
                    {...support?.discoverMoreButton}
                >
                    {formatMessage({
                        id: 'cart_default.cart_support.discover_more_button',
                        defaultMessage: 'Discover More',
                    })}
                </Button>
            </HStack>
            {showSupportChatSection && (
                <HStack {...support?.supportChatSection}>
                    <AdviceIcon
                        {...support?.supportIcon}
                        role="img"
                        aria-label={formatMessage({
                            id: 'cart_support.icon.chat.label',
                            defaultMessage: 'Chat support icon',
                        })}
                    />
                    <Text {...support?.text}>
                        {formatMessage({
                            id: 'cart_default.cart_support.chat_message',
                            defaultMessage: 'Chat with us!Mon-Fri 8:00-18:30Sat 8:00-12:00',
                        })}
                    </Text>
                </HStack>
            )}
        </VStack>
    )
}

export default CartSupport
